import Linkify from 'react-linkify';

const MyLinkify = ({ children }) => {
    return (
        <Linkify
            componentDecorator={(decoratedHref, decoratedText, key) => (
                <a target="_blank" href={decoratedHref} key={key}>
                    {decoratedText}
                </a>
            )}
        >
            {children}
        </Linkify>
    );
};

export default MyLinkify;
